import React, { useEffect, useState } from 'react'
import SimpleModal from 'components/SimpleModal'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import { ModalContent, Section } from '../style'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { KANBAN } from 'store/modules/kanban/types'
import { Col, Row } from 'reactstrap'
import CustomSelect from 'components/Select'
import useRedux from 'hooks/useRedux'
import * as kanbanActions from 'store/modules/kanban/actions'
import InputCustom from 'components/Inputs'

interface ModalMotivoProps {
  isOpen: boolean
}

const ModalMotivo = ({ isOpen }: ModalMotivoProps) => {
  const { motivoMovimentacao, optionsSelect, loadingSelect } = useSelector<
    ApplicationState,
    KANBAN
  >((state) => state.kanban)

  const { dispatch } = useRedux()

  const [invalidMotivo, setInvalidMotivo] = useState(false)
  const [invalidObservacao, setInvalidObservacao] = useState(false)

  const handleConfirmar = () => {
    let hasError = false

    if (!motivoMovimentacao.motivoId) {
      setInvalidMotivo(true)
      hasError = true
    } else {
      setInvalidMotivo(false)
    }

    if (!motivoMovimentacao.observacao.trim()) {
      setInvalidObservacao(true)
      hasError = true
    } else {
      setInvalidObservacao(false)
    }

    if (hasError) return

    dispatch(kanbanActions.executarMovimentacaoComMotivoSaga())

    handleClose()
  }

  const handleClose = () => {
    setInvalidMotivo(false)
    setInvalidObservacao(false)

    dispatch(kanbanActions.setMovimentacaoPendente(null))
    dispatch(kanbanActions.setIsOpenModalMotivo(false))
    dispatch(kanbanActions.cleanMotivoMovimentacao())
  }

  useEffect(() => {
    if (isOpen) {
      dispatch(kanbanActions.getMotivosPerdaSaga())
    }
  }, [isOpen, dispatch])

  return (
    <SimpleModal
      dataBackdrop="static"
      isOpen={isOpen}
      toggle={handleClose}
      size="md"
      header={<SimpleTitleCard>Motivo da Movimentação</SimpleTitleCard>}
      footer={
        <Row>
          <Col>
            <CustomButton background="#662D91" onClick={handleClose}>
              Cancelar
            </CustomButton>
          </Col>
          <Col>
            <CustomButton
              background="var(--verde-riber)"
              onClick={handleConfirmar}
            >
              Confirmar
            </CustomButton>
          </Col>
        </Row>
      }
    >
      <ModalContent>
        <Section>
          <div className="d-flex flex-column gap-3">
            <div>
              <label className="form-label">Motivo *</label>
              <CustomSelect
                placeholder="Selecione o motivo"
                options={optionsSelect.motivosPerda}
                accessorLabel="descricao"
                accessorValue="id"
                value={motivoMovimentacao.motivoId}
                isLoading={loadingSelect.motivosPerda}
                onChange={(value) => {
                  dispatch(
                    kanbanActions.setMotivoMovimentacao({
                      ...motivoMovimentacao,
                      motivoId: value
                    })
                  )
                  if (value) setInvalidMotivo(false)
                }}
                invalid={invalidMotivo}
              />
              {invalidMotivo && (
                <div className="text-danger small mt-1">
                  Selecione um motivo
                </div>
              )}
            </div>

            <div>
              <label className="form-label">Descrição *</label>
              <InputCustom
                type="textarea"
                placeholder="Descreva detalhadamente o motivo da movimentação..."
                value={motivoMovimentacao.observacao}
                onChange={(e) => {
                  dispatch(
                    kanbanActions.setMotivoMovimentacao({
                      ...motivoMovimentacao,
                      observacao: e.target.value || ''
                    })
                  )
                  if (e.target.value.trim()) setInvalidObservacao(false)
                }}
                invalid={invalidObservacao}
              />
              {invalidObservacao && (
                <div className="text-danger small mt-1">
                  Informe uma descrição
                </div>
              )}
            </div>
          </div>
        </Section>
      </ModalContent>
    </SimpleModal>
  )
}

export default ModalMotivo
